import { render } from "./TemplateMinimal.vue?vue&type=template&id=4323bd0e&scoped=true"
import script from "./TemplateMinimal.vue?vue&type=script&lang=js"
export * from "./TemplateMinimal.vue?vue&type=script&lang=js"

import "./TemplateMinimal.vue?vue&type=style&index=0&id=4323bd0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4323bd0e"]])

export default __exports__